import React, { useContext } from 'react';

import { MDText } from 'i18n-react';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { HeroInput } from '../../../../../common/Hero/HeroInput/HeroInput';
import { HeroVehicle } from '../../../../../common/Hero/HeroVehicle/HeroVehicle';
import { useHeroRouteChangeHelpers } from '../../../../../common/Hero/Hooks/useHeroRouteChangeHelpers';
import { HeroFinance } from '../../../../../experiments/useFinanceExperiment/HeroFinance/HeroFinance';
import Lock from '../../../../../fastlane/lock/Lock';
import LocalTexts from '../../../../HomepageTexts.json';
import { HeroProps } from '../../Hero';
import { HeroContent } from '../HeroContent/HeroContent';

import { TrustPilotHero } from './TrustPilotHero';

import styles from './HomepageVRM.scss';

const LocalT = new MDText(LocalTexts);

type HomepageVRMProps = {
  inProgress?: boolean;
  isFinanceTransition?: boolean;
  loadingHandler?: (value: any) => void;
  onFinanceSubmit?: (isOnFinance: boolean) => void;
} & HeroProps;

export const HomepageVRM = ({
  inProgress = false,
  isFinanceTransition = false,
  loadingHandler,
  onFinanceSubmit,
}: HomepageVRMProps) => {
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);

  const {
    onNotMyCarClick: onNotMyCarClickHandler,
    setMileageUrl,
    showMileage,
  } = useHeroRouteChangeHelpers({ vehicle });

  if (isFinanceTransition && loadingHandler && onFinanceSubmit) {
    return (
      <div className={styles.component}>
        <HeroFinance
          loadingHandler={loadingHandler}
          onFinanceSubmit={onFinanceSubmit}
        />
      </div>
    );
  }

  return (
    <Lock lock={inProgress}>
      <div className={styles.component}>
        {showMileage
          ? (<HeroVehicle
            {...{ onNotMyCarClickHandler, vehicle }}
          />)
          : (<HeroContent
            subTitle={LocalT.translate('hero.subTitle')}
            title={LocalT.translate('hero.title')}
          />)}
        <HeroInput
          className={styles.heroInput}
          setShowMileage={setMileageUrl}
          {...{
            inProgress,
            loadingHandler,
            showMileage,
            vehicle,
          }}
        />
        <TrustPilotHero />
      </div>
    </Lock>
  );
};
